module.exports = __webpack_public_path__ + "img/red_icon1.963d4b47.png";